export const listboxTokens = {
  listbox: {
    root: {
      background: '{overlay.select.background}',
      disabledBackground: '{formField.disabledBackground}',
      borderColor: '{overlay.select.borderColor}',
      invalidBorderColor: '{formField.invalidBorderColor}',
      color: '{overlay.select.color}',
      disabledColor: '{formField.disabledColor}',
      shadow: '0 4px 18px 0 rgba(53, 67, 88, 0.08)',
      borderRadius: '{borderRadius.sm}',
      focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
      },
      transitionDuration: '{transition.duration}'
    },
    list: {
      padding: '0.5rem',
      gap: '0',
      header: {
        // Aligns the "select all" row horizontally with the option rows.
        padding: '0.4375rem 0.75rem'
      }
    },
    option: {
      // Flat rows: selection is indicated by the checkbox, not a row fill.
      focusBackground: '{surface.100}',
      selectedBackground: 'transparent',
      selectedFocusBackground: '{surface.100}',
      color: '{surface.1000}',
      focusColor: '{surface.1000}',
      selectedColor: '{surface.1000}',
      selectedFocusColor: '{surface.1000}',
      padding: '0.4375rem 0.75rem',
      borderRadius: '{borderRadius.sm}',
      gap: '0.5rem'
    },
    optionGroup: {
      background: '{surface.100}',
      color: '{surface.1000}',
      fontWeight: '600',
      padding: '0.5rem 0.75rem'
    },
    checkmark: {
      color: '{primary.color}',
      gap: '0.5rem'
    },
    emptyMessage: {
      padding: '0.5rem 0.75rem'
    }
  }
};

export type ListboxTokens = typeof listboxTokens;
